
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    SortBox: () => import("@/components/SortBox.vue"),
  },
})
export default class CompaniesIndex extends Vue {
  companies: any = [];
  limit: number = 5;
  totalRows: number = 5;
  sortColumns: Record<string, string> = {
    name: "Empresa",
    owner: "Responsable",
    deletedAt: "Estado",
  };
  currentSort: Record<string, string> = {
    col: "status",
    dir: "asc",
  };

  mounted() {
    this.loadCompanies(1, this.currentSort);
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadCompanies(page, this.currentSort);
  }

  async deleteCompany(companyId) {
    try {
      let response: any = await (this
        .$root as any)._put(`businesses/${companyId}/status`, { status: 2 });
      this.$router.go(0);
    } catch (e) {
      console.log(e);
    }
  }

  async loadCompanies(page: number, sort: Record<string, string>) {
    this.currentSort = sort;
    const response: any = await (this.$root as any)._post("businesses/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
    });
    this.companies = response.data;
    this.totalRows = response.totalRows;
  }

  getOwnerName(owner) {
    if (owner) {
      return owner.last_name && owner.last_name.trim()
        ? `${owner.name} ${owner.last_name}`
        : owner.name;
    } else {
      return "";
    }
  }
}
